module.exports = __webpack_public_path__ + "static/fonts/BMKIRANGHAERANG-TTF.ttf?7ae1e968";